angular.module("vgresiduos").controller("EquipmentListCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "unidade/equipamentos");
		};
	}
]);
